module.exports = __webpack_public_path__ + "img/personal-ico.44d1b3df.svg";